var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"wallpaper"},[_c('Toolbar'),_c('div',{staticStyle:{"overflow-y":"auto","height":"calc(100vh - 104px)"}},[_c('div',{staticStyle:{"padding-bottom":"8vh"}}),_c('LoginInput')],1),_c('LoginFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }